import React, { useState } from 'react';

// 1. MUI Icon Imports
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ChatIcon from '@mui/icons-material/Chat'; // Equivalent to MessageSquare
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // Equivalent to Award
import SupportAgentIcon from '@mui/icons-material/SupportAgent'; // Equivalent to LifeBuoy
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn'; // Equivalent to Refund/Refresh
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';


const MOCK_TIMELINE_DATA = [
  {
    id: 1,
    type: 'refund',
    date: '2023-10-25 10:15 AM',
    title: 'Refund Processed - Order #ORD-2305',
    description: 'Amount: -$45.00 | Item damaged in transit',
    status: 'Completed'
  },
  {
    id: 2,
    type: 'support',
    date: '2023-10-24 03:30 PM',
    title: 'Support Ticket #TKT-9921 Created',
    description: 'Issue: Damaged item reported by customer.',
    status: 'Resolved'
  },
  {
    id: 3,
    type: 'message',
    date: '2023-10-24 02:00 PM',
    title: 'Message Received from Agent (Alex)',
    description: 'Hi Sarah, I am looking into your issue now...',
    status: 'Read'
  },
  {
    id: 4,
    type: 'order',
    date: '2023-10-22 05:30 PM',
    title: 'Order Placed - #ORD-2305',
    description: 'Total: $210.50 | Items: 3',
    status: 'Delivered'
  },
  {
    id: 5,
    type: 'loyalty',
    date: '2023-10-22 05:30 PM',
    title: 'Loyalty Points Earned',
    description: '+150 Points (Purchase Bonus)',
    status: 'Balance: 1200'
  },
];

const CustomerTimeline = () => {
  const [filter, setFilter] = useState('all');
  const navigate=useNavigate();
  // 2. Updated getIcon to use MUI components and 'sx' for sizing
  const getIcon = (type: any) => {
    switch (type) {
      case 'order': return <ShoppingCartIcon sx={{ fontSize: 18 }} />;
      case 'message': return <ChatIcon sx={{ fontSize: 18 }} />;
      case 'loyalty': return <EmojiEventsIcon sx={{ fontSize: 18 }} />;
      case 'support': return <SupportAgentIcon sx={{ fontSize: 18 }} />;
      case 'refund': return <AssignmentReturnIcon sx={{ fontSize: 18 }} />;
      default: return <CalendarTodayIcon sx={{ fontSize: 18 }} />;
    }
  };

  const filteredEvents = filter === 'all'
    ? MOCK_TIMELINE_DATA
    : MOCK_TIMELINE_DATA.filter(event => event.type === filter);

  return (
    <><div className="main_title">
      <h1>Customer Activity Timeline</h1>
      <p>
        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
        <button onClick={() => navigate("/manage-customers")}>
          Manage Customers
        </button>{" "}
        - Customer Activity Timeline
      </p>
    </div>
      <div className="customer-timeline-container">
        <div className="timeline-header">
    
          <div className="timeline-filters">
            {['all', 'order', 'message', 'loyalty', 'support', 'refund'].map((type) => (
              <button
                key={type}
                className={`filter-btn ${filter === type ? 'active' : ''}`}
                onClick={() => setFilter(type)}
              >
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="timeline-content">
          {filteredEvents.length === 0 ? (
            <p className="no-events">No events found for this category.</p>
          ) : (
            <ul className="timeline-list">
              {filteredEvents.map((event) => (
                <li key={event.id} className={`timeline-item ${event.type}`}>
                  <div className="timeline-marker">
                    {getIcon(event.type)}
                  </div>
                  <div className="timeline-card">
                    <div className="card-header">
                      <span className="event-title">{event.title}</span>
                      <span className="event-date">{event.date}</span>
                    </div>
                    <div className="card-body">
                      <p>{event.description}</p>
                    </div>
                    <div className="card-footer">
                      <span className="event-status">{event.status}</span>
                
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div></>
  );
};

export default CustomerTimeline;